import { action, observable } from "mobx";
import moment, { type Moment } from "moment";
import { Entity, SitePage, SharedSettingsExport } from "../..";
import { SharedSettingsEntityType } from "../EntityType";
import SharedSettingsImport from "./Import";

export default class SharedSettingsImportEntity extends Entity {
    constructor(en?: Partial<SharedSettingsImportEntity>) {
        super();
        if (en)
            this.update(en);
    }

    @observable type: SharedSettingsEntityType;
    @observable import: SharedSettingsImport;

    @observable sitePage: SitePage | null;

    createdDate: Moment;

    @action
    update(session: Partial<SharedSettingsExport>) {
        super.update(session);
    }

    static fromJson(json: any) {
        return new SharedSettingsImportEntity({
            ...json,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            import: json.import ? SharedSettingsImport.fromJson(json.import) : undefined,
            sitePage: json.sitePage ? SitePage.fromJson(json.sitePage) : undefined,
        });
    }
}
